import * as React from "react";
const SvgFilter20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 19,
        fill: "black",
        viewBox: "0 0 21 19"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M.5 0h20l-7 9.333v7.36l-6 2.25v-9.61L.5 0Zm4 2 5 6.667v7.39l2-.75v-6.64L16.5 2h-12Z",
      clipRule: "evenodd"
    })
  );
export default SvgFilter20Px;
